// mutations.js

export default {
   updateMenuTree(state, payload){
       state.menuTree = payload
   },
   updateMenuItems(state, payload) {
       state.menuItems = payload;
   }
};
